import { useIntl } from 'react-intl';

import { Button } from '@xing-com/button';
import {
  IllustrationEmptyStateContacts,
  IllustrationEmptyStateError,
} from '@xing-com/illustrations';
import { BodyCopy } from '@xing-com/typography';

import { Container, StyledHeadline } from './user-message.styles';

export enum UserMessageType {
  empty = 'empty',
  emptyUserBags = 'emptyUserBags',
  error = 'error',
}

type UserMessageProps = {
  type: UserMessageType;
};

export const UserMessage: React.FC<UserMessageProps> = ({ type }) => {
  const { formatMessage } = useIntl();
  const reloadPage = (): void => window.location.reload();

  const content = {
    [UserMessageType.error]: (
      <>
        <IllustrationEmptyStateError />
        <StyledHeadline sizeConfined="xlarge">
          {formatMessage({ id: 'PD_ERROR_STATE_HEADLINE' })}
        </StyledHeadline>
        <BodyCopy sizeConfined="medium" size="small">
          {formatMessage({ id: 'PD_ERROR_STATE_DESCRIPTION' })}
        </BodyCopy>
        <Button variant="tertiary" onClick={reloadPage}>
          {formatMessage({ id: 'PD_ERROR_STATE_BUTTON_LABEL' })}
        </Button>
      </>
    ),
    [UserMessageType.empty]: (
      <>
        <IllustrationEmptyStateContacts />
        <StyledHeadline>
          {formatMessage({ id: 'PD_EMPTY_STATE_HEADLINE' })}
        </StyledHeadline>
        <BodyCopy>
          {formatMessage({ id: 'PD_EMPTY_STATE_DESCRIPTION' })}
        </BodyCopy>
      </>
    ),
    [UserMessageType.emptyUserBags]: (
      <>
        <IllustrationEmptyStateContacts />
        <StyledHeadline>
          {formatMessage({ id: 'PD_EMPTY_STATE_USER_BAGS_PAGE_HEADLINE' })}
        </StyledHeadline>
        <BodyCopy>
          {formatMessage({ id: 'PD_EMPTY_STATE_USER_BAGS_PAGE_DESCRIPTION' })}
        </BodyCopy>
      </>
    ),
  };

  return <Container>{content[type]}</Container>;
};
